module.exports = __WEBPACK_EXTERNAL_MODULE_https_test_staff_k_portal_ru_remoteEntry_js_c8166ef4__;